
  <!-----------FEELING UNWELL?--------------->
  <section class="unwell type_one  pdb_80 pdt_10">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-12 col-md-12  text-center">
            <!---------col----------->
            <div class="heading white  tp_one theme-text-color">
               <h1>Feeling unwell? </h1>
               <p>Assess your symptoms online with our free symptom checker.</p>
            </div>
            <a href="#" class="theme_btn tp_one"><span class="linearicons-syringe"></span>Symptom Checker</a>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
   </div>
</section>
<!-----------unwell-end-------------->
 
<!-----------footer--------------->
<section class="footer type_two pdt_100  pdb_70">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
            <!---------col----------->
            <div class="footer_widgets type_two">
               <h3 class="widgets_title logo">
                  <a href="#">
                  <img src="assets/image/footer-logo.png" class="img-fluid" alt="logo" />
                  </a>
               </h3>
               <div class="widget_content">
                  <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. </p>
                  <a href="#" class="read_more tp_one">  View More<span class="linearicons-arrow-right"></span></a>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
            <!---------col----------->
            <div class="footer_widgets type_two">
               <h3 class="widgets_title">Prevention</h3>
               <div class="widget_content">
                  <ul class="links">
                     <li><a href="#">Basic Symptoms</a></li>
                     <li><a href="#">How to Protect</a></li>
                     <li><a href="#">How is it Transmitted</a></li>
                     <li><a href="#">Call our Experts</a></li>
                  </ul>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
            <!---------col----------->
            <div class="footer_widgets type_two">
               <h3 class="widgets_title">Protection</h3>
               <div class="widget_content">
                  <ul class="links">
                     <li><a href="#">What should I do</a></li>
                     <li><a href="#">Handwashing process</a></li>
                     <li><a href="#">FAQs</a></li>
                     <li><a href="#">Latest Updates</a></li>
                  </ul>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
            <!---------col----------->
            <div class="footer_widgets type_two">
               <h3 class="widgets_title">Contacts</h3>
               <div class="widget_content">
                  <h2 class="emergency_contact"><a href="#">+240 (8) 8234 3555</a></h2>
                  <ul class="contact_all">
                     <li><a href="#"><span class="linearicons-home4"></span>Street: 9, baderin street. City: Oshodi</a></li>
                     
                     <li><a href="#"><span class="linearicons-envelope-open"></span>Email: <small>info@logo.net</small></a></li>
                  </ul>
               </div>
            </div>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
   </div>
</section>
<!-----------footer-end-------------->
<!-----------footerlast UNWELL?--------------->
<section class="footerlast type_two  pdb_40 pdt_50 ">
   <div class="container">
      <div class="row">
         <!---------row----------->
         <div class="col-lg-8 col-md-12">
            <!---------col----------->
            <ul class="font-responsive-6">
               <li>© Copyright {{currYear}}</li>
               <li>&nbsp; |</li>
               <li> &nbsp;&nbsp; <a href="#">Terms of Use </a></li>
               <li>|</li>  
               <li>&nbsp; <a href="#">  Privacy Policy  </a></li>
               </ul>
            <!---------col-end---------->
         </div>
         <div class="col-lg-4 col-md-12 text-right font-responsive-para">
            <!---------col----------->
            <p>Developed  by<small> <a href="#"> NowNow digital systems</a></small></p>
            <!---------col-end---------->
         </div>
         <!----------row-end---------->
      </div>
   </div>
</section>
<!-----------footerlast-end-------------->
<!------main-content-end----->